import { render } from "./Tutarial.vue?vue&type=template&id=19963362&scoped=true"
import script from "./Tutarial.vue?vue&type=script&lang=js"
export * from "./Tutarial.vue?vue&type=script&lang=js"

import "./Tutarial.vue?vue&type=style&index=0&id=19963362&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19963362"]])

export default __exports__